import { render, staticRenderFns } from "./InsightsConfiguration.vue?vue&type=template&id=5567f67a&scoped=true&"
import script from "./InsightsConfiguration.vue?vue&type=script&lang=js&"
export * from "./InsightsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./InsightsConfiguration.vue?vue&type=style&index=0&id=5567f67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5567f67a",
  null
  
)

export default component.exports